module.exports = __webpack_public_path__ + "bb6b31bc0ed88cc76fa4facf9269a607.svg";